import '../../style/index.less';
import './index.less'; // style dependencies
// deps-lint-skip: tooltip
//# sourceMappingURL=index.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/popover/style/index.js
// module id = 813
// module chunks = 0